import Button from 'antd/es/button';
import Input from 'antd/es/input';
import styled from 'styled-components';
import tinycolor from 'tinycolor2';

import { colorPalette } from '@components/GlobalStyle';

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  max-width: 600px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.token.colorBorder};
  border-radius: ${({ theme }) => theme.token.borderRadius}px;
  background: ${({ theme }) => theme.token.colorBgContainer};
`;

export const StyledTextArea = styled(Input.TextArea)`
  border: none;
  box-shadow: none;
  padding: 12px 16px;

  &.ant-input-textarea-auto-size {
    min-height: 24px;
    max-height: 200px;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const ButtonBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled(Button)<{ $isEnabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  ${({ $isEnabled }) =>
    $isEnabled
      ? `
  background: ${tinycolor(colorPalette.secondary).darken(20).toString()} !important;
  color: white !important;

  &:hover {
    background: ${tinycolor(colorPalette.secondary).darken(30).toString()} !important;
    color: white !important;
  }
  `
      : ''};
`;

export const ModelSelectorButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const ModelMenuItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;
